<script setup lang="ts"></script>

<template>
  <div class="Badge">
    <slot />
  </div>
</template>

<style>
.Badge {
  display: inline-flex;
  color: var(--color-white);
  padding: 2px 10px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 22px;
  background: var(--color-forest-80);
  font-size: 14px;

  &.Badge--mini {
    padding: 0 8px;
    font-size: 12px;
  }
}
</style>
